import { styled } from "../../Theme";

export const ResourcePageContainer = styled.div`
  /*width: 100%;*/
  max-width: 100%;
  padding: 5%;
`;
